<!--
  新建 客户特殊字段
  prop:
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="customer">
    <!-- 客户模板 -->
    <template v-if="item.attr === 'templateId'">
      <el-select v-model="form[item.attr]" @change="handleTemp" :disabled="item.nonEditable===1" placeholder="请选择">
        <el-option
          v-for="arr in item.valueArrMap"
          :key="arr.key"
          :label="arr.value"
          :value="arr.key">
        </el-option>
      </el-select>
    </template>
    <!-- 客户电话 -->
    <v-phone
      v-else-if="item.attr === 'phone'"
      @numChange="phoneSave"
      :attrValue.sync="form.phone">
    </v-phone>
    <!-- 地址 -->
    <v-address
      @change="addressSave"
      v-else-if="item.attr === 'address'"
      :attrValue="form.address">
    </v-address>
    <!-- 创建人 -->
    <v-manager
      v-else-if="item.attr === 'userId'"
      :item="item"
      :form="form">
    </v-manager>
    <!-- 客户-查重 -->
    <div class="customerName" v-else-if="item.attr === 'name'">
      <el-input
        v-model="form[item.attr]"
        @focus="repeatListShow = true"
        @blur="repeatListShow = false"
      >
      </el-input>
      <div class="repeat-list" v-show="isNameCheck && repeatListShow && isCheckRepeat">
        <h4 class="title" v-show="listData.length">已存在以下客户，请勿重复添加</h4>
        <ul>
          <li class="item" v-for="(item, index) in listData" :key="index">{{item.name}}</li>
        </ul>
      </div>
    </div>
    <!-- 添加联系人 -->
    <add-contact
      v-else-if="item.attr === 'addContact'"
      :item="item"
      :child="child"
    ></add-contact>
  </div>
</template>

<script>
import Vue from 'vue'
// import * as api from 'src/api'
import { mapActions } from 'vuex'
import vAddress from '../address'
import vPhone from '../phone'
import vManager from '../manager'
import addContact from '../add-contact'
// let lazy

export default {
  props: {
    item: {
      type: Object,
      default: {}
    },
    form: {
      type: Object,
      default: {}
    },
    isNameCheck: {
      type: Boolean,
      default: false
    },
    isCheckRepeat: {
      type: Boolean,
      default: false
    },
    listData: {
      type: Array,
      default: []
    },
    child: {
      type: String
    }
  },
  data () {
    return {
      repeatListShow: false
    }
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    addressSave (arr) {
      if (this.item.required && !arr.address.trim()) {
        this.$set(this.form, 'address', '')
      } else {
        this.$set(this.form, 'address', arr)
      }
      this.setAttr('address')
    },
    phoneSave (arr) {
      Vue.set(this.form, 'phone', arr)
      this.setAttr('phone')
    },
    // 监听选择框的变化
    handleTemp (value) {
      this.$emit('change', value, 'temp')
    }
  },
  components: {
    vAddress,
    vPhone,
    vManager,
    addContact
  }
}
</script>
<style lang="less" scoped>
  .repeat-list {
    position: absolute;
    width: 250px;
    max-height: 300px;
    background-color: #fff;
    z-index: 100;
    overflow: auto;
    box-shadow: 0 0 4px 0 rgba(137, 137, 137, 0.5);
    left: 2px;
    top: 40px;
    .title {
      font-size: 14px;
      line-height: 32px;
      border-bottom: 1px solid #ededed;
      padding-left: 10px;
    }
    .item {
      line-height: 28px;
      padding: 0 10px;
      color: #888;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// index.vue?5ef7e9a8